import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { getInitials } from '@/shared/utils/getInitials';

import { userByIdQueryOptions } from '../api/user-directory.api';

export interface UseUserDisplayResult {
  name: string | null;
  avatarUrl: string | null;
  /** 1-2 char initials for `<AvatarFallback>`. Null when no name is available. */
  initials: string | null;
  isLoading: boolean;
  isError: boolean;
}

/** Resolves a user UUID to display-ready fields for `<Avatar>` + name. */
export function useUserDisplay(userId: string | null | undefined): UseUserDisplayResult {
  const query = useQuery(userByIdQueryOptions(userId));

  return useMemo<UseUserDisplayResult>(() => {
    const name = query.data?.name.trim() || null;
    return {
      name,
      avatarUrl: query.data?.avatarUrl ?? null,
      initials: name ? getInitials(name) : null,
      isLoading: query.isLoading,
      isError: query.isError,
    };
  }, [query.data, query.isLoading, query.isError]);
}
